import React from 'react';
import { TableBody, TableRow } from '../../../../../../../../../CommonComponents/OPL/Table/Table';
import { Text } from '../../../../../../../../../CommonComponents/OPL/Text/Text';

export const TransfersEmpty = () => {
  return (
    <TableBody height={48}>
      <TableRow p="16">
        <Text color="neutral.500" fontSize="small">
          There are no transactions available.
        </Text>
      </TableRow>
    </TableBody>
  );
};
